import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { deleteData, fetchData, postData, putData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const AssinaturaContext = createContext();

export const useAssinatura = () => useContext(AssinaturaContext);

export const AssinaturaProvider = ({ children }) => {
  const [cobrancas, setCobrancas] = useState([]);
  const { showAlert } = useAlert();
  const { showMessage } = useMessage();

  const fetchCobrancas = useCallback(async () => {
    try {
      const result = await fetchData('/Assinatura');
      setCobrancas(result || []);
      return result || [];
    } catch (error) {
      console.error('Erro ao buscar assinaturas:', error);
      showMessage(`Erro ao buscar assinaturas! ${error?.message || error}`, 'danger');
      return [];
    }
  }, [showMessage]);

  useEffect(() => {
    fetchCobrancas();
  }, [fetchCobrancas]);

  const addCobranca = async (cobranca) => {
    const result = await postData('/Assinatura', cobranca);
    setCobrancas((prev) => [...prev, result]);
    showAlert('Assinatura cadastrada com sucesso!');
    return result;
  };

  const updateCobranca = async (cobranca) => {
    const result = await putData('/Assinatura', cobranca);
    setCobrancas((prev) => prev.map((item) => (item.id === result.id ? result : item)));
    showAlert('Assinatura alterada com sucesso!');
    return result;
  };

  const deleteCobranca = async (id) => {
    await deleteData('/Assinatura', { assinaturaId: id });
    setCobrancas((prev) => prev.filter((item) => item.id !== id));
    showAlert('Assinatura excluída com sucesso!');
  };

  const buscarFaturas = async (filtro) => {
    const result = await postData('/Assinatura/Buscar', filtro);
    return result || [];
  };

  const lancarPagamento = async (payload) => {
    const result = await putData('/Assinatura/LancarPagamento', payload);
    showAlert('Pagamento lançado com sucesso!');
    return result;
  };

  const adiarBloqueio = async (payload) => {
    const result = await putData('/AssinaturaFatura/AdiarBloqueio', payload);
    showAlert('Bloqueio adiado com sucesso!');
    return result;
  };
  const buscarRecebidos = async (dataIni, dataFim) => {
    return await fetchData('/Assinatura/Recebidos', { dataIni, dataFim });
  };

  const buscarAtrasados = async (dataBase) => {
    return await fetchData('/Assinatura/Atrasados', { dataBase });
  };

  const value = useMemo(() => ({
    cobrancas,
    setCobrancas,
    fetchCobrancas,
    addCobranca,
    updateCobranca,
    deleteCobranca,
    buscarFaturas,
    lancarPagamento,
    adiarBloqueio,
    buscarRecebidos,
    buscarAtrasados,
  }), [cobrancas, fetchCobrancas]);

  return (
    <AssinaturaContext.Provider value={value}>
      {children}
    </AssinaturaContext.Provider>
  );
};
